import { useState, useEffect, useCallback } from 'react';

export const useFetchSupplier = () => {
    //マスタデータリスト
    const [supplierList, setSupplierList] = useState([])
    const supplierListSet = useCallback((val) => {
        setSupplierList(val)
    }, [setSupplierList])
    //マスタ取得
    const Call_API = useCallback(async () => {
        const url = "https://bahati.work/api/kizen/API_Supplier_R.php";
        await fetch(url,
            {
                credentials: "same-origin",
            }).then((res) => {
                if (!res.ok) {
                    throw new Error(`${res.status} ${res.statusText}`);
                }
                return res.json();
            })
            .then((json) => {
                supplierListSet(json)
            })
            .catch((reason) => {
                console.log(reason);
            });
    }, [supplierListSet])

    useEffect(() => {
        Call_API()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return { supplierList }
}